import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import i18n from './locates'
import '@/permission'
import moment from 'moment'
import echarts from 'echarts'
// import _ from 'lodash'
import base from './base'
import 'default-passive-events'

Vue.config.productionTip = false

Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
// Vue.prototype.$_ = _

Vue.prototype.API_URL = process.env.VUE_APP_BASE_API
Vue.prototype.UPLOAD_URL = process.env.VUE_APP_UPLOAD_PATH

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(base)

/**
 * input自动获取焦点
 */
 Vue.directive('inputfocus', {
  inserted (el) {
    el.querySelector('input').focus()
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
